/**
 * uiTokens.js — tokens visuais derivados do design system da designer (Claude Design).
 *
 * São os "soft tints" semânticos (containers suaves usados em chips/banners) e a
 * escala neutra "slate" (cinzas frios). MUI não traz esses tons por default; isto
 * é a ponte de tokens (Passo 0 do handoff designer↔dev). Use estes em vez de hex cru.
 *
 * Cores semânticas "main" (#1976d2 azul, #d32f2f erro, #ed6c02 alerta) já são o
 * default do tema MUI — não duplicar aqui; usar palette.* para essas.
 */

// Containers suaves p/ chips/banners de status (bg + borda + texto forte/fraco).
export const softTints = {
  success: { bg: '#e7f8ee', border: '#bfe8d0', fg: '#13693a', sub: '#3d8c5f', main: '#1FA855' },
  warning: { bg: '#fff4e5', border: '#ffd9a8', fg: '#9a4f06', sub: '#b06a26', main: '#ed6c02' },
  error:   { bg: '#fdecea', border: '#f5c2bd', fg: '#9b251c', sub: '#bd564d', main: '#d32f2f' },
  info:    { bg: '#eaf2fc', border: '#d3e3f7', fg: '#1565c0', sub: '#1565c0', main: '#1976d2' },
  neutral: { bg: '#f6f8fa', border: '#eaeef1', fg: '#5a6671', sub: '#8a949d' },
};

// Escala neutra "slate" (cinzas frios) da designer, p/ valores crus fiéis ao mockup.
export const slate = {
  ink: '#1f2937',   // texto principal (= text.primary global)
  sub: '#6b7682',   // texto secundário (= text.secondary global)
  line: '#e3e7eb',  // bordas/divisores (= divider global)
  bg: '#f4f6f8',    // fundo de página/conteúdo
  100: '#f6f8fa',
  200: '#eaeef1',
  300: '#cdd5dc',
  400: '#aeb8c0',
  500: '#8a949d',
  600: '#5a6671',
  700: '#3a4750',
};

// Sombra sutil padrão de card (o "flat + shadow" do mockup).
export const cardShadow = '0 1px 2px rgba(16,24,40,0.04)';
